import {Card, Layout, SkeletonBodyText, SkeletonDisplayText, SkeletonPage, TextContainer} from "@shopify/polaris";

function PageSkeleton() {
    return (
        <SkeletonPage primaryAction>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText/>
                    </Card>
                    <Card >
                        <TextContainer>
                            <SkeletonDisplayText size="small"/>
                            <SkeletonBodyText/>
                        </TextContainer>
                    </Card>
                    <Card >
                        <TextContainer>
                            <SkeletonDisplayText size="small"/>
                            <SkeletonBodyText/>
                        </TextContainer>
                    </Card>
                </Layout.Section>
                <Layout.Section>
                    <Card>
                        <div>
                            <TextContainer>
                                <SkeletonDisplayText size="small"/>
                                <SkeletonBodyText lines={2}/>
                            </TextContainer>
                        </div>
                        <div>
                            <SkeletonBodyText lines={1}/>
                        </div>
                    </Card>
                    <Card>
                        <div>
                            <TextContainer>
                                <SkeletonDisplayText size="small"/>
                                <SkeletonBodyText lines={2}/>
                            </TextContainer>
                        </div>
                        <div>
                            <SkeletonBodyText lines={2}/>
                        </div>
                    </Card>
                </Layout.Section>
            </Layout>
        </SkeletonPage>
    );
}

export default PageSkeleton;
